// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"Menu_menu-item__IgaDE","menu__link":"Menu_menu__link__1e6Rh"};